export default __webpack_public_path__ + "static/media/search.f79c8c4f.svg";